import React from "react";
import Panel from "../../Panel/Panel";
import BookingPaymentMethod from "../BookingPaymentMethod";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  ElementsConsumer,
  CardElement,
} from "@stripe/react-stripe-js";

export default class BookingPaymentSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: this.props.paymentErrors,
      stripe: null,
      add_new_card_visible: this.props.sign_out_visible && Object.keys(this.props.sign_in_information).length ? true : false,
    };
  }

  async componentDidMount() {
    const stripe = await loadStripe(this.props.public_gateway_key);
    this.setState({ stripe: stripe });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.paymentErrors.length !== prevProps.paymentErrors.length) {
      this.setState({ errors: { header_errors: this.props.paymentErrors.header_errors, field_errors: { card_validation_error: this.props.paymentErrors.header_errors } }, disableNameOnCard: false }, () => {
        if(this.props.paymentErrors) {
          // this.setState({ errors: this.props.paymentErrors, disableNameOnCard: false })
          this.props.onGoto('Payment');
          this.props.onClearPaymentMethod()
        }
      });
    };
    if (
      prevProps.payment_method &&
      prevProps.payment_method.payment_token &&
      this.props.payment_method &&
      !this.props.payment_method.payment_token
    ) {
      this.setState({ disableNameOnCard: false });
    };

  }

  render() {
    if (this.state.stripe) {
      return (
        <Elements
          stripe={this.state.stripe}
          options={{
            locale:
              navigator.languages && navigator.languages.length
                ? navigator.languages[0]
                : navigator.language,
          }}
        >
          <ElementsConsumer>
            {({ stripe, elements }) => (
              <div className="PaymentSection">
                <a id="Payment" name="Payment"></a>
                <Panel
                  name="Payment"
                  expanded={this.props.expanded}
                  onExpandCollapse={
                    this.props.guestSectionValid &&
                    this.props.customerFormFieldsValid == true
                      ? this.props.onExpandCollapse
                      : null
                  }
                  header={this.renderHeader()}
                  body={this.renderBody(elements)}
                />
              </div>
            )}
          </ElementsConsumer>
        </Elements>
      );
    } else {
      return null;
    }
  }

  renderHeader() {
    return (
      <div>
        <span
          className={
            "step-number " + (this.props.validPayment ? "complete" : "")
          }
        >
          {this.props.validPayment ? "✔" : this.props.step}
        </span>
        <h3>{I18n.t("payment")}</h3>
        {this.props.expanded ? null : this.renderCollapsedDetail()}
      </div>
    );
  }

  renderBody(elements) {
    return (
      <div className="expand-collapse-body">
        {this.renderErrors()}
        <BookingPaymentMethod
          {...this.props}
          paymentErrors={this.state.errors}
          disableNameOnCard={this.state.disableNameOnCard}
          onResetCardElement={this.onResetCardElement}
          add_new_card_visible={this.state.add_new_card_visible}
          onToggleAddNewCard={this.onToggleAddNewCard}
        />
        <div className="continue-btn-wrapper">
          <button
            type="button"
            className="btn"
            onClick={(e) => {
              this.validateCard(e, elements);
            }}
          >
            {I18n.t("continue")}
          </button>
        </div>
      </div>
    );
  }

  renderCollapsedDetail() {
    var card = this.getCard();
    if (card) {
      if (card.brand == "mastercard") {
        var cardClass = "mastercard";
      } else {
        var cardClass = card.brand ? card.brand.replace(/ /, "_") : "";
      }
      return (
        <div className="collapsed-detail">
          {
            this.props.voucher
              ?
              <h5 className="success-voucher-display">
                <strong>{I18n.t('voucher') + ` ${this.props.voucher.redemption_code}`}</strong>
              </h5>
              :
              null
          }
          <h5>
            {card.brand && card.brand != "unknown" ? (
              <span className={"credit-card-icon xsmall " + cardClass}></span>
            ) : null}
            <strong>
              {card.brand && card.brand != "unknown"
                ? I18n.t(card.brand.replace(/ /, "_"))
                : I18n.t("card")}
            </strong>{" "}
            {I18n.t("ending_in").toLowerCase()} <strong>{card.last_4}</strong>
          </h5>
        </div>
      );
    }
  }

  renderErrors() {
    if (
      this.state.errors &&
      this.state.errors.header_errors &&
      this.state.errors.header_errors.length > 0
    ) {
      var errors = this.state.errors.header_errors.map((error) => {
        return (
          <li key={error} dangerouslySetInnerHTML={{ __html: error }}></li>
        );
      });

      return (
        <div
          className="alert alert-danger"
          style={{ margin: "-15px 0 15px 0" }}
        >
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  /**
   * Helper function
   */

  getCard() {
    if (
      this.props.validPayment &&
      Object.keys(this.props.payment_method).length &&
      !this.props.card_id
    ) {
      var card = {
        brand: null,
        last_4: this.props.payment_method.payment_token
          ? this.props.payment_method.payment_token.card.last4
          : null,
      };

      return card;
    } else if (
      this.props.guest_information &&
      this.props.guest_information.cards &&
      this.props.guest_information.cards.length > 0
    ) {
      for (
        var i = 0, ilen = this.props.guest_information.cards.length;
        i < ilen;
        i++
      ) {
        if (this.props.guest_information.cards[i].id == this.props.card_id) {
          return this.props.guest_information.cards[i];
        }
      }
    }
  }

  validateCard = async (e, elements) => {
    if (e && e.preventDefault && e.stopPropagation) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (this.props.displayVoucherInput) {
      await this.props.getVoucher();
    }

    if (
      this.props.card_id ||
      (this.props.payment_method && this.props.payment_method.payment_token)
    ) {
      this.props.paymentValid(true);
      this.props.onGoto("ReviewAndBook");
    } else {
      if (
        this.props.guest_information &&
        this.props.guest_information.cards &&
        this.props.guest_information.cards.length &&
        !this.state.add_new_card_visible &&
        !this.props.card_id
      ) {
        var errors = {
          header_errors: [I18n.t("select_or_enter_payment_details")],
        };


        this.setState({ errors: errors });
      } else if (
        this.props.payment_method &&
        this.props.payment_method.name_on_card
      ) {
        var stripe = this.state.stripe;
        var cardElement = elements.getElement(CardElement);

        if (!stripe || !elements) {
          console.log('We should never hit this! Either Stripe or Elements is not loaded!')
          return;
        }

        const result = await stripe.createPaymentMethod({
          type: "card",
          card: cardElement,
          billing_details: {
            name: this.props.payment_method.name_on_card,
          },
        });

        this.setState({ disableNameOnCard: true });

        if (result.error) {
          var errors = {
            header_errors: [result.error.message],
            field_errors: { card_validation_error: result.error.message },
          };

          this.setState({ errors: errors });
        } else if (result.paymentMethod) {
          this.props.setPaymentToken(result.paymentMethod);
          this.props.onGoto("ReviewAndBook");
          this.props.substep === "Payment" ? this.props.clearSubStep() : null;
          this.props.paymentErrors.length
            ? this.props.clearPaymentErrors()
            : null;
        } else {
          console.log('should not hit here potential async issue')
        }
      } else {
        var errors = {
          header_errors: [I18n.t("name_on_card_error")],
          field_errors: {
            name_on_card_error: I18n.t("name_on_card_error"),
          },
        };

        this.setState({ errors: errors });
      }
    }
  };

  onResetCardElement = () => {
    this.setState({ disableNameOnCard: false, errors: {} });
  };

  onToggleAddNewCard = (e) => {
    e.stopPropagation();
    e.preventDefault();


    this.setState(
      { add_new_card_visible: !this.state.add_new_card_visible },
      () => {
        this.props.onClearPaymentMethod();
      }
    );
  };
}
